import React, { useEffect, useMemo, useState } from "react";
import { Box, Grid } from "@mui/material";

import { fetchLatestTelemetry } from "../Api/telemetryApi";
import TelemetrySummary from "../components/TelemetrySummary";
import TelemetryCard from "../components/TelemetryCard";
import TelemetryLoading from "../components/TelemetryLoading";
import TelemetryError from "../components/TelemetryError";
import TelemetryEmpty from "../components/TelemetryEmpty";

export default function TelemetryDashboardPage() {
  const [telemetry, setTelemetry] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");

  const totalDevices = telemetry.length;

  const normalCount = useMemo(() => {
    return telemetry.filter((item) => item.status === "NORMAL").length;
  }, [telemetry]);

  const alertCount = useMemo(() => {
    return telemetry.filter((item) => item.status !== "NORMAL").length;
  }, [telemetry]);

  const loadTelemetry = async () => {
    try {
      const result = await fetchLatestTelemetry();
      setTelemetry(Array.isArray(result) ? result : []);
      setLastUpdated(new Date().toLocaleTimeString());
      setError("");
    } catch (err) {
      setError(err.message || "Failed to fetch telemetry data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTelemetry();

    const interval = setInterval(() => {
      loadTelemetry();
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f7fb",
        p: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1400, mx: "auto" }}>
        <TelemetrySummary
          totalDevices={totalDevices}
          lastUpdated={lastUpdated}
          normalCount={normalCount}
          alertCount={alertCount}
        />

        {loading ? (
          <TelemetryLoading />
        ) : error ? (
          <TelemetryError message={error} />
        ) : telemetry.length === 0 ? (
          <TelemetryEmpty />
        ) : (
          <Grid container spacing={3}>
            {telemetry.map((item) => (
              <Grid item xs={12} key={item.id || item.device_id}>
                <TelemetryCard item={item} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Box>
  );
}